import { useContext } from "react";

/// React router dom
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import PermissionRoute from "../routes/PermissionRoute";
import { ADMIN_ONLY } from "../routes/roleAccess";
import RoleRoute from "../routes/RoleRoute";

/// Css
import "./chart.css";
import "./index.css";
import "./step.css";

/// Layout
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";
import Setting from "./layouts/Setting";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import AdminTaskKanban from "./components/Dashboard/AdminTaskKanban";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Draggable from "./components/Dashboard/Draggable";
import Home from "./components/Dashboard/Home";
import LatestActivity from "./components/Dashboard/LatestActivity";
import Messages from "./components/Dashboard/Messages";
import ProjectDetails from "./components/Dashboard/ProjectDetails";
import Task from "./components/Dashboard/Task";
import TaskReportingSummary from "./components/Dashboard/TaskReportingSummary";
import Teams from "./components/Dashboard/Teams";
import ProcurementExecutionDashboard from "./components/Dashboard/ProcurementExecutionDashboard";
import ProcurementPipelineDetail from "./components/Dashboard/ProcurementPipelineDetail";

// Users
import Permissions from "./components/Users/Permissions";
import Profile from "./components/Users/Profile";
import ReportingTreeManager from "./components/Users/ReportingTreeManager";
import Roles from "./components/Users/Roles";
import Users from "./components/Users/Users";

// Work Orders
import WorkOrderAdd from "./components/WorkOrders/WorkOrderAdd";
import WorkOrderCards from "./components/WorkOrders/WorkOrderCards";
import WorkOrderDetails from "./components/WorkOrders/WorkOrderDetails";
import WorkOrderEdit from "./components/WorkOrders/WorkOrderEdit";
import WorkOrderGantt from "./components/WorkOrders/WorkOrderGantt";
import WorkOrders from "./components/WorkOrders/WorkOrders";

//Dpr
import DprAdd from "./components/Dpr/DprAdd";
import DprEdit from "./components/Dpr/DprEdit";
import DprList from "./components/Dpr/DprList";
import HindranceRegister from "./components/Dpr/HindranceRegister";
import ManpowerDashboard from "./components/Dpr/ManpowerDashboard";
// Documents
import PendingApprovals from "./components/Approvals/PendingApprovals";
import DocumentControlUpload from "./components/DocumentControl/DocumentControlUpload";
import TCList from "./components/DocumentControl/TCList";
import TDSList from "./components/DocumentControl/TDSList";
import DocumentList from "./components/Documents/DocumentList";
import DocumentUpload from "./components/Documents/DocumentUpload";

// Vendor Management
import VendorAdd from "./components/Vendors/VendorAdd";
import VendorCategories from "./components/Vendors/VendorCategories";
import VendorEdit from "./components/Vendors/VendorEdit";
import VendorList from "./components/Vendors/VendorList";
import VendorView from "./components/Vendors/VendorView";

// Material Indent
import IndentAdd from "./components/Material/IndentAdd";
import IndentEdit from "./components/Material/IndentEdit";
import IndentList from "./components/Material/IndentList";

// Material Purchase Order
import OtherPurchaseOrderList from "./components/Material/OtherPurchaseOrderList";
import PurchaseOrderAdd from "./components/Material/PurchaseOrderAdd";
import PurchaseOrderEdit from "./components/Material/PurchaseOrderEdit";
import PurchaseOrderList from "./components/Material/PurchaseOrderList";
import VendorWorkOrderAdd from "./components/Material/VendorWorkOrderAdd";
import VendorWorkOrderBillingAdd from "./components/Material/VendorWorkOrderBillingAdd";
import VendorWorkOrderBillingList from "./components/Material/VendorWorkOrderBillingList";
import VendorWorkOrderBillingView from "./components/Material/VendorWorkOrderBillingView";
import VendorWorkOrderEdit from "./components/Material/VendorWorkOrderEdit";
import VendorWorkOrderList from "./components/Material/VendorWorkOrderList";
import VendorJMRAdd from "./components/Material/VendorJMRAdd";
import VendorJMREdit from "./components/Material/VendorJMREdit";
import VendorJMRList from "./components/Material/VendorJMRList";
import ContractorJMRAdd from "./components/Material/ContractorJMRAdd";
import ContractorJMREdit from "./components/Material/ContractorJMREdit";
import ContractorJMRList from "./components/Material/ContractorJMRList";

// Inventory
import InventoryDashboard from "./components/Inventory/InventoryDashboard";
import InventoryIssueForm from "./components/Inventory/InventoryIssueForm";
import InventoryPurchaseOrderForm from "./components/Inventory/InventoryPurchaseOrderForm";
import InventoryPurchaseOrderList from "./components/Inventory/InventoryPurchaseOrderList";
import InventoryStockLedger from "./components/Inventory/InventoryStockLedger";
import InventoryStockSummary from "./components/Inventory/InventoryStockSummary";
import InventoryTransferForm from "./components/Inventory/InventoryTransferForm";
import WarehouseForm from "./components/Inventory/WarehouseForm";
import WarehouseList from "./components/Inventory/WarehouseList";

// Material Delivery
import DeliveryAdd from "./components/Material/DeliveryAdd";
import DeliveryEdit from "./components/Material/DeliveryEdit";
import DeliveryList from "./components/Material/DeliveryList";
import ContractorDeliveryList from "./components/Material/ContractorDeliveryList";
import ContractorDeliveryAdd from "./components/Material/ContractorDeliveryAdd";

// Material Inspection Report (MIR)
import MIRAdd from "./components/Material/MIRAdd";
import MIREdit from "./components/Material/MIREdit";
import MIRList from "./components/Material/MIRList";

// Billings
import BillingAdd from "./components/Billings/BillingAdd";
import BillingEdit from "./components/Billings/BillingEdit";
import BillingList from "./components/Billings/BillingList";

// JMR
import JMRList from "./components/ITC/JMRList";

// WIR
import WirAdd from "./components/Wir/WirAdd";
import WirEdit from "./components/Wir/WirEdit";
import WirList from "./components/Wir/WirList";

// Measurement Sheets
import MeasurementSheetAdd from "./components/MeasurementSheets/MeasurementSheetAdd";
import MeasurementSheetEdit from "./components/MeasurementSheets/MeasurementSheetEdit";
import MeasurementSheetList from "./components/MeasurementSheets/MeasurementSheetList";

// TC Report
import TCReportAdd from "./components/ITC/TCReportAdd";
import TCReportEdit from "./components/ITC/TCReportEdit";
import TCReportList from "./components/ITC/TCReportList";

// Handover
import HandoverAdd from "./components/Handover/HandoverAdd";
import HandoverEdit from "./components/Handover/HandoverEdit";
import HandoverList from "./components/Handover/HandoverList";
import HotoReadinessDashboard from "./components/Handover/HotoReadinessDashboard";

//Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";

/// Product List
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";

/// Charts
import ChartJs from "./components/charts/Chartjs";
import SparklineChart from "./components/charts/Sparkline";
////import Chartist from "./components/charts/chartist";
import ApexChart from "./components/charts/apexcharts";
import RechartJs from "./components/charts/rechart";

/// Bootstrap
import UiAccordion from "./components/bootstrap/Accordion";
import UiAlert from "./components/bootstrap/Alert";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiGrid from "./components/bootstrap/Grid";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiModal from "./components/bootstrap/Modal";
import UiPagination from "./components/bootstrap/Pagination";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";

//Redux
//import Todo from "./pages/Todo";

// Widget
import Widget from "./pages/Widget";

/// Table
import BootstrapTable from "./components/table/BootstrapTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import SortingTable from "./components/table/SortingTable/SortingTable";

/// Form
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Element from "./components/Forms/Element/Element";
import FormValidation from "./components/Forms/FormValidation/FormValidation";
import Pickers from "./components/Forms/Pickers/Pickers";
import Wizard from "./components/Forms/Wizard/Wizard";

/// Pages
//import Registration from "./pages/Registration";
//import Login from "./pages/Login";
// import ForgotPassword from "./pages/ForgotPassword";
import { ThemeContext } from "../context/ThemeContext";
import Accounts from "./components/Accounts/Accounts";
import ContractorPaymentList from "./components/Accounts/ContractorPaymentList";
import ContractualWorkOrderAdd from "./components/Accounts/ContractualWorkOrderAdd";
import ContractualWorkOrderList from "./components/Accounts/ContractualWorkOrderList";
import DebitList from "./components/Accounts/DebitList";
import ExpenseAdd from "./components/Accounts/ExpenseAdd";
import ExpenseEdit from "./components/Accounts/ExpenseEdit";
import GSTReconciliation from "./components/Accounts/GSTReconciliation";
import OfficeExpenseForm from "./components/Accounts/OfficeExpenseForm";
import OfficeExpenseList from "./components/Accounts/OfficeExpenseList";
import VendorPaymentList from "./components/Accounts/VendorPaymentList";
import PurchaseOrderPaymentList from "./components/Accounts/PurchaseOrderPaymentList";
import OtherPurchaseOrderPaymentList from "./components/Accounts/OtherPurchaseOrderPaymentList";
import Billing from "./components/Billings/Billing";
import BillingOverview from "./components/Billings/BillingOverview";
import AddClient from "./components/Clients/AddClient";
import ClientsList from "./components/Clients/ClientsList";
import EditClient from "./components/Clients/EditClient";
import ClientTicketing from "./components/ClientTickets/ClientTicketing";
import AllNotifications from "./components/Dashboard/AllNotifications";
import CommercialDashboard from "./components/Dashboard/CommercialDashboard";
import AttendancePage from "./components/HR/AttendancePage";
import HrAndCrm from "./components/HR/HrAndCrm";
import PayrollSettingsPage from "./components/HR/PayrollSettingsPage";
import SalaryAccounts from "./components/HR/SalaryAccounts";
import StaffAllAttendance from "./components/HR/StaffAllAttendance";
import StaffAttendancePage from "./components/HR/StaffAttendancePage";
import StaffSalaryOverview from "./components/HR/StaffSalaryOverview";
import StaffSelfAttendance from "./components/HR/StaffSelfAttendance";
import StaffLiveTracking from "./components/HR/StaffLiveTracking";
import ComplianceDossierPage from "./components/HR/ComplianceDossierPage";
import ReimbursementPage from "./components/HR/Reimbursement/ReimbursementPage";
import ContractorBillingAdd from "./components/Material/ContractorBillingAdd";
import ContractorBillingList from "./components/Material/ContractorBillingList";
import ContractorBillingView from "./components/Material/ContractorBillingView";
import Purchase from "./components/Material/Purchase";
import PurchaseOrderOverview from "./components/Material/PurchaseOrderOverview";
import MomAdd from "./components/Mom/MomAdd";
import MomEdit from "./components/Mom/MomEdit";
import MomList from "./components/Mom/MomList";
import OtherMomAdd from "./components/OtherMom/OtherMomAdd";
import OtherMomEdit from "./components/OtherMom/OtherMomEdit";
import OtherMomList from "./components/OtherMom/OtherMomList";
import Operations from "./components/Operstion/Operations";
import OperationsOverview from "./components/Operstion/OperationsOverview";
import TestCertificates from "./components/Operstion/TestCertificates";
import TestCertificatesList from "./components/Operstion/TestCertificatesList";
import WarrantyCards from "./components/Operstion/WarrantyCards";
import WarrantyCardsList from "./components/Operstion/WarrantyCardsList";
import Payments from "./components/Payments/Payments";
import PhysicalProgressPlan from "./components/Progress/PhysicalProgressPlan";
import PhysicalProgressReport from "./components/Progress/PhysicalProgressReport";
import MilestoneTracker from "./components/Projects/MilestoneTracker";
import ProjectAdd from "./components/Projects/ProjectAdd";
import ProjectEdit from "./components/Projects/ProjectEdit";
import ProjectList from "./components/Projects/ProjectList";
import ProjectMcs from "./components/Projects/ProjectMcs";
import RiskRegister from "./components/Projects/RiskRegister";
import Reconciliation from "./components/Reconciliation/Reconciliation";
import RolePermissions from "./components/Users/RolePermissions";
import BoqAmendmentForm from "./components/WorkOrders/BoqAmendmentForm";
import BoqAmendmentList from "./components/WorkOrders/BoqAmendmentList";
import WorkOrderBOQ from "./components/WorkOrders/WorkOrderBOQ";
import EmployeeAlerts from "./pages/EmployeeAlerts";
import EmployeeCRM from "./pages/EmployeeCRM";
import EmployeePerformance from "./pages/EmployeePerformance";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import LockScreen from "./pages/LockScreen";
import ActivityMaster from "./pages/Masters/ActivityMaster";
import BoqUnitTypeMaster from "./pages/Masters/BoqUnitTypeMaster";
import DeductionTypeMaster from "./pages/Masters/DeductionTypeMaster";
import DocumentTypeMaster from "./pages/Masters/DocumentTypeMaster";
import EmailTemplateMaster from "./pages/Masters/EmailTemplateMaster";
import ExpenseTypeMaster from "./pages/Masters/ExpenseTypeMaster";
import MeasurementSheetTypeMaster from "./pages/Masters/MeasurementSheetTypeMaster";
import OfficeMaster from "./pages/Masters/OfficeMaster";
import ProductCategoryMaster from "./pages/Masters/ProductCategoryMaster";
import ProductMaster from "./pages/Masters/ProductMaster";
import ProjectCategoryMaster from "./pages/Masters/ProjectCategoryMaster";
import ProjectTypeMaster from "./pages/Masters/ProjectTypeMaster";
import ProjectMenuButtonMaster from "./pages/Masters/ProjectMenuButtonMaster";
import ScopeTypeMaster from "./pages/Masters/ScopeTypeMaster";
import WorkerTypeMaster from "./pages/Masters/WorkerTypeMaster";
import MenuManager from "./pages/MenuManager";
import SearchPage from "./pages/SearchPage";
import UserGuides from "./pages/UserGuides";
import UserGuideAdd from "./pages/UserGuideAdd";

// Equipment
import DeploymentLogs from "./components/Equipment/DeploymentLogs";
import EquipmentDeploy from "./components/Equipment/EquipmentDeploy";
import EquipmentForm from "./components/Equipment/EquipmentForm";
import EquipmentList from "./components/Equipment/EquipmentList";
import EquipmentView from "./components/Equipment/EquipmentView";
import IdleEquipmentReport from "./components/Equipment/IdleEquipmentReport";

// QC Inspections
import QCForm from "./components/QC/QCForm";
import QCList from "./components/QC/QCList";
import QCReport from "./components/QC/QCReport";

// Safety Module
import SafetyChecklistForm from "./components/Safety/SafetyChecklistForm";
import SafetyForm from "./components/Safety/SafetyForm";
import SafetyList from "./components/Safety/SafetyList";
import SafetyReport from "./components/Safety/SafetyReport";
import StatutoryApprovals from "./components/StatutoryApprovals/StatutoryApprovals";


const Markup = () => {
  const allroutes = [
    { url: "/search", component: <SearchPage /> },
    /// Commercial Dashboard
    {
      url: "commercial/dashboard",
      component: (
        <PermissionRoute permission={["read:billings", "read:workorders"]}>
          <CommercialDashboard />
        </PermissionRoute>
      ),
    },
    /// Physical Progress Monitoring
    {
      url: "progress/plan",
      component: (
        <PermissionRoute permission={["read:progress", "read:dprs"]}>
          <PhysicalProgressPlan />
        </PermissionRoute>
      ),
    },
    {
      url: "progress/report",
      component: (
        <PermissionRoute permission={["read:progress", "read:dprs"]}>
          <PhysicalProgressReport />
        </PermissionRoute>
      ),
    },
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "procurement-pipeline-dashboard", component: <ProcurementExecutionDashboard /> },
    { url: "pipeline-dashboard", component: <ProcurementExecutionDashboard /> },
    { url: "procurement-pipeline-detail", component: <ProcurementPipelineDetail /> },
    { url: "pipeline-detail", component: <ProcurementPipelineDetail /> },
    { url: "dashboard-dark", component: <DashboardDark /> },
    { url: "draggable", component: <Draggable /> },
    { url: "messages", component: <Messages /> },
    { url: "project-details", component: <ProjectDetails /> },
    { url: "latest-activity", component: <LatestActivity /> },
    { url: "task", component: <Task /> },
    {
      url: "admin-task",
      component: (
        <PermissionRoute permission="read:tasks">
          <AdminTaskKanban />
        </PermissionRoute>
      ),
    },
    {
      url: "my-tasks",
      component: <AdminTaskKanban viewMode="staff" />,
    },
    {
      url: "task-reporting-summary",
      component: (
        <PermissionRoute permission="read:tasks">
          <TaskReportingSummary />
        </PermissionRoute>
      ),
    },
    { url: "teams", component: <Teams /> },
    // {url :"forgot-password", component:<ForgotPassword />},
    {
      url: "client-tickets",
      component: <ClientTicketing />,
    },
    {
      url: "statutory-approvals",
      component: (
        <PermissionRoute permission="read:statutory-approvals">
          <StatutoryApprovals />
        </PermissionRoute>
      ),
    },
    {
      url: "pending-approvals",
      component: (
        <RoleRoute allowedRoles={["admin", "client", "po"]}>
          <PermissionRoute
            permission={[
              "read:pending-approvals",
              "read:documents",
              "read:jmrs",
              "read:mirs",
              "read:measurement-sheets",
              "read:moms",
              "read:tcs",
              "read:statutory-approvals",
              "read:indents",
              "read:deliveries"
            ]}
          >
            <PendingApprovals />
          </PermissionRoute>
        </RoleRoute>
      ),
    },
    {
      url: "employee-crm",
      component: (
        <PermissionRoute permission="read:employees">
          <EmployeeCRM />
        </PermissionRoute>
      ),
    },
    {
      url: "employee-performance",
      component: (
        <PermissionRoute permission="read:employees">
          <EmployeePerformance />
        </PermissionRoute>
      ),
    },
    {
      url: "employee-alerts",
      component: (
        <PermissionRoute permission="read:employees">
          <EmployeeAlerts />
        </PermissionRoute>
      ),
    },
    {
      url: "payroll-settings",
      component: (
        <PermissionRoute permission="read:payroll">
          <PayrollSettingsPage />
        </PermissionRoute>
      ),
    },
    {
      url: "my-attendance",
      component: <StaffSelfAttendance />,
    },
    {
      url: "attendance",
      component: (
        <PermissionRoute permission="read:attendance">
          <AttendancePage />
        </PermissionRoute>
      ),
    },
    {
      url: "staff-attendance",
      component: (
        <PermissionRoute permission="read:attendance">
          <StaffAttendancePage />
        </PermissionRoute>
      ),
    },
    {
      url: "staff-salary",
      component: (
        <PermissionRoute permission="read:payroll">
          <StaffSalaryOverview />
        </PermissionRoute>
      ),
    },
    {
      url: "salary-accounts",
      component: (
        <PermissionRoute permission="read:payroll">
          <SalaryAccounts />
        </PermissionRoute>
      ),
    },
    {
      url: "staff-all-attendance",
      component: (
        <PermissionRoute permission="read:attendance">
          <StaffAllAttendance />
        </PermissionRoute>
      ),
    },
    {
      url: "live-tracking",
      component: <StaffLiveTracking />,
    },
    {
      url: "staff-live-tracking",
      component: <StaffLiveTracking />,
    },
    {
      url: "statutory-compliance",
      component: (
        <PermissionRoute permission="read:compliance-dossiers">
          <ComplianceDossierPage />
        </PermissionRoute>
      ),
    },
    {
      url: "compliance-dossier",
      component: (
        <PermissionRoute permission="read:compliance-dossiers">
          <ComplianceDossierPage />
        </PermissionRoute>
      ),
    },
    {
      url: "staff-reimbursements",
      component: (
        <PermissionRoute permission="read:reimbursements">
          <ReimbursementPage />
        </PermissionRoute>
      ),
    },
    {
      url: "reimbursements",
      component: (
        <PermissionRoute permission="read:reimbursements">
          <ReimbursementPage />
        </PermissionRoute>
      ),
    },

    /// Users 
    // PERMISSION BASED 
    {
      url: "users",
      component: (
        <PermissionRoute permission="read:users">
          <Users />
        </PermissionRoute>
      ),
    },
    {
      url: "reporting-tree",
      component: (
        <RoleRoute allowedRoles={ADMIN_ONLY}>
          <ReportingTreeManager />
        </RoleRoute>
      ),
    },
    {
      url: "user-profile",
      component: (
        <Profile />
      ),
    },
    {
      url: "roles",
      component: (
        <PermissionRoute permission="read:roles">
          <Roles />
        </PermissionRoute>
      ),
    },
    {
      url: "role-permissions",
      component: (
        <PermissionRoute permission="read:permissions">
          <RolePermissions />
        </PermissionRoute>
      ),
    },
    {
      url: "permissions",
      component: (
        <PermissionRoute permission="read:permissions">
          <Permissions />
        </PermissionRoute>
      ),
    },
    {
      url: "menu-manager",
      component: (
        <PermissionRoute permission="read:menus">
          <MenuManager />
        </PermissionRoute>
      ),
    },
    {
      url: "test-certificates/add",
      component: (
        <PermissionRoute permission="create:tcs">
          <TestCertificates />
        </PermissionRoute>
      ),
    },

    {
      url: "test-certificates/edit/:id",
      component: (
        <PermissionRoute permission="edit:tcs">
          <TestCertificates />
        </PermissionRoute>
      ),
    },

    {
      url: "test-certificates-list",
      component: (
        <PermissionRoute permission="read:tcs">
          <TestCertificatesList />
        </PermissionRoute>
      ),
    },
    {
      url: "warranty-cards/add",
      component: (
        <PermissionRoute permission="create:tcs">
          <WarrantyCards />
        </PermissionRoute>
      ),
    },
    {
      url: "warranty-cards/edit/:id",
      component: (
        <PermissionRoute permission="edit:tcs">
          <WarrantyCards />
        </PermissionRoute>
      ),
    },
    {
      url: "warranty-cards-list",
      component: (
        <PermissionRoute permission="read:tcs">
          <WarrantyCardsList />
        </PermissionRoute>
      ),
    },
    // Clients 
    {
      url: "clients",
      component: (
        <PermissionRoute permission="read:clients">
          <ClientsList />
        </PermissionRoute>
      ),
    },
    {
      url: "clients/add",
      component: (
        <PermissionRoute permission="create:clients">
          <AddClient />
        </PermissionRoute>
      ),
    },
    {
      url: "clients/edit/:id",
      component: (
        <PermissionRoute permission="edit:clients">
          <EditClient />
        </PermissionRoute>
      ),
    },

    /// Work Orders 
    {
      url: "work-orders",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrders />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/cards",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrderCards />
        </PermissionRoute>
      ),
    },
    {
      url: "work-order-cards",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrderCards />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/add",
      component: (
        <PermissionRoute permission="create:workorders">
          <WorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/edit/:id",
      component: (
        <PermissionRoute permission="edit:workorders">
          <WorkOrderEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/details/:id",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrderDetails />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/:id",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrderDetails />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/:id/boq",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrderBOQ />
        </PermissionRoute>
      ),
    },
        {
      url: "boq-amendments",
      component: (
        <PermissionRoute permission="read:boqs">
          <BoqAmendmentList />
        </PermissionRoute>
      ),
    },
{
      url: "boq/amendment/list",
      component: (
        <PermissionRoute permission="read:boqs">
          <BoqAmendmentList />
        </PermissionRoute>
      ),
    },
    {
      url: "boq-amendments/add",
      component: (
        <PermissionRoute permission="create:boqs">
          <BoqAmendmentForm />
        </PermissionRoute>
      ),
    },
    {
      url: "boq-amendments/edit/:id",
      component: (
        <PermissionRoute permission="edit:boqs">
          <BoqAmendmentForm />
        </PermissionRoute>
      ),
    },
    {
      url: "work-orders/:id/gantt",
      component: (
        <PermissionRoute permission="read:workorders">
          <WorkOrderGantt />
        </PermissionRoute>
      ),
    },

    // Vendor Management 
    {
      url: "vendors",
      component: (
        <PermissionRoute permission="read:vendors">
          <VendorList />
        </PermissionRoute>
      ),
    },
    {
      url: "vendors/add",
      component: (
        <PermissionRoute permission="create:vendors">
          <VendorAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "vendors/edit/:id",
      component: (
        <PermissionRoute permission="edit:vendors">
          <VendorEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "vendors/view/:id",
      component: (
        <PermissionRoute permission="read:vendors">
          <VendorView />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-categories",
      component: (
        <PermissionRoute permission="read:masters">
          <VendorCategories />
        </PermissionRoute>
      ),
    },

    // Document & Approval Management 
    {
      url: "documents",
      component: (
        <PermissionRoute permission="read:documents">
          <DocumentList />
        </PermissionRoute>
      ),
    },
    {
      url: "documents/upload",
      component: (
        <PermissionRoute permission={["create:documents",]}>
          <DocumentUpload />
        </PermissionRoute>
      ),
    },
    {
      url: "documents/edit/:id",
      component: (
        <PermissionRoute permission={["edit:documents",]}>
          <DocumentUpload />
        </PermissionRoute>
      ),
    },
    {
      url: "tds",
      component: (
        <PermissionRoute permission="read:documents">
          <TDSList />
        </PermissionRoute>
      ),
    },
    {
      url: "tds/upload",
      component: (
        <PermissionRoute permission={["create:documents",]}>
          <DocumentControlUpload />
        </PermissionRoute>
      ),
    },
    {
      url: "tds/edit/:id",
      component: (
        <PermissionRoute permission={["edit:documents",]}>
          <DocumentControlUpload />
        </PermissionRoute>
      ),
    },
    {
      url: "tc-documents",
      component: (
        <PermissionRoute permission="read:documents">
          <TCList />
        </PermissionRoute>
      ),
    },
    {
      url: "tc-documents/upload",
      component: (
        <PermissionRoute permission={["create:documents",]}>
          <DocumentControlUpload />
        </PermissionRoute>
      ),
    },
    {
      url: "tc-documents/edit/:id",
      component: (
        <PermissionRoute permission={["edit:documents",]}>
          <DocumentControlUpload />
        </PermissionRoute>
      ),
    },
    {
      url: "document-types",
      component: (
        <PermissionRoute permission="read:masters">
          <DocumentTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "worker-types",
      component: (
        <PermissionRoute permission="read:masters">
          <WorkerTypeMaster />
        </PermissionRoute>
      ),
    },

    // Material Indent 
    {
      url: "indent",
      component: (
        <PermissionRoute permission="read:indents">
          <IndentList />
        </PermissionRoute>
      ),
    },
    {
      url: "indent/add",
      component: (
        <PermissionRoute permission="create:indents">
          <IndentAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "indent/edit/:id",
      component: (
        <PermissionRoute permission="edit:indents">
          <IndentEdit />
        </PermissionRoute>
      ),
    },

    // Material Purchase Order 
    {
      url: "purchase-orders",
      component: (
        <PermissionRoute permission="read:pos">
          <PurchaseOrderList />
        </PermissionRoute>
      ),
    },
    {
      url: "purchase-orders/other",
      component: (
        <PermissionRoute permission="read:pos">
          <OtherPurchaseOrderList />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-work-orders",
      component: (
        <PermissionRoute permission="read:vendorwo">
          <VendorWorkOrderList />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-work-orders/add",
      component: (
        <PermissionRoute permission="create:vendorwo">
          <VendorWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-work-orders/edit/:id",
      component: (
        <PermissionRoute permission="edit:vendorwo">
          <VendorWorkOrderEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-work-order-billing",
      component: (
        <PermissionRoute permission="read:vendor-work-order-billings">
          <VendorWorkOrderBillingList />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-work-order-billing/add",
      component: (
        <PermissionRoute permission="create:vendor-work-order-billings">
          <VendorWorkOrderBillingAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-work-order-billing/view/:id",
      component: (
        <PermissionRoute permission="read:vendor-work-order-billings">
          <VendorWorkOrderBillingView />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-jmr",
      component: (
        <PermissionRoute permission="read:vendor-jmrs">
          <VendorJMRList />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-jmr/add",
      component: (
        <PermissionRoute permission="create:vendor-jmrs">
          <VendorJMRAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-jmr/edit/:id",
      component: (
        <PermissionRoute permission="edit:vendor-jmrs">
          <VendorJMREdit />
        </PermissionRoute>
      ),
    },
    // Contractor JMR
    {
      url: "contractor-jmr",
      component: (
        <PermissionRoute permission="read:contractor-jmrs">
          <ContractorJMRList />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-jmr/add",
      component: (
        <PermissionRoute permission="create:contractor-jmrs">
          <ContractorJMRAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-jmr/edit/:id",
      component: (
        <PermissionRoute permission="edit:contractor-jmrs">
          <ContractorJMREdit />
        </PermissionRoute>
      ),
    },
    {
      url: "purchase-orders/add",
      component: (
        <PermissionRoute permission="create:pos">
          <PurchaseOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "purchase-orders/edit/:id",
      component: (
        <PermissionRoute permission="edit:pos">
          <PurchaseOrderEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "purchase-orders-by-project",
      component: (
        <PermissionRoute permission="read:pos">
          <Purchase />
        </PermissionRoute>
      ),
    },
    {
      url: "purchase-order-overview",
      component: (
        <PermissionRoute permission="read:pos">
          <PurchaseOrderOverview />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-dashboard",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryDashboard />
        </PermissionRoute>
      ),
    },
    {
      url: "warehouses",
      component: (
        <PermissionRoute permission="read:inventory">
          <WarehouseList />
        </PermissionRoute>
      ),
    },
    {
      url: "warehouses/add",
      component: (
        <PermissionRoute permission="create:inventory">
          <WarehouseForm />
        </PermissionRoute>
      ),
    },
    {
      url: "warehouses/edit/:id",
      component: (
        <PermissionRoute permission="edit:inventory">
          <WarehouseForm />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-purchase-orders",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryPurchaseOrderList />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-purchase-orders/add",
      component: (
        <PermissionRoute permission="create:inventory">
          <InventoryPurchaseOrderForm />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-purchase-orders/edit/:id",
      component: (
        <PermissionRoute permission="edit:inventory">
          <InventoryPurchaseOrderForm />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-purchase-orders/view/:id",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryPurchaseOrderForm />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-stock",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryStockSummary />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-transfers",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryTransferForm />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-issues",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryIssueForm />
        </PermissionRoute>
      ),
    },
    {
      url: "inventory-stock-ledger",
      component: (
        <PermissionRoute permission="read:inventory">
          <InventoryStockLedger />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-billing",
      component: (
        <PermissionRoute permission="read:contractualwo-billings">
          <ContractorBillingList />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-billing/add",
      component: (
        <PermissionRoute permission="create:contractualwo-billings">
          <ContractorBillingAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-billing/view/:id",
      component: (
        <PermissionRoute permission="read:contractualwo-billings">
          <ContractorBillingView />
        </PermissionRoute>
      ),
    },
    {
      url: "operations",
      component: (
        <PermissionRoute permission="read:operations">
          <Operations />
        </PermissionRoute>
      ),
    },
    {
      url: "mom/add",
      component: (
        <PermissionRoute permission="create:moms">
          <MomAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "mom/edit/:id",
      component: (
        <PermissionRoute permission="edit:moms">
          <MomEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "mom/list",
      component: (
        <PermissionRoute permission="read:moms">
          <MomList />
        </PermissionRoute>
      ),
    },
    {
      url: "other-mom/add",
      component: (
        <PermissionRoute permission="create:moms">
          <OtherMomAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "other-mom/edit/:id",
      component: (
        <PermissionRoute permission="edit:moms">
          <OtherMomEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "other-mom/list",
      component: (
        <PermissionRoute permission="read:moms">
          <OtherMomList />
        </PermissionRoute>
      ),
    },
    {
      url: "operations-overview",
      component: (
        <PermissionRoute permission="read:operations">
          <OperationsOverview />
        </PermissionRoute>
      ),
    },
    {
      url: "accounts",
      component: (
        <PermissionRoute permission="read:accounts">
          <Accounts />
        </PermissionRoute>
      ),
    },
    {
      url: "payments",
      component: (
        <PermissionRoute permission={["read:workorders", "read:billings", "read:accounts"]}>
          <Payments />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-payments",
      component: (
        <PermissionRoute permission="read:accounts">
          <ContractorPaymentList />
        </PermissionRoute>
      ),
    },
    {
      url: "vendor-payments",
      component: (
        <PermissionRoute permission="read:accounts">
          <VendorPaymentList />
        </PermissionRoute>
      ),
    },
    {
      url: "purchase-order-payments",
      component: (
        <PermissionRoute permission="read:accounts">
          <PurchaseOrderPaymentList />
        </PermissionRoute>
      ),
    },
    {
      url: "other-purchase-order-payments",
      component: (
        <PermissionRoute permission={["read:accounts", "read:pos"]}>
          <OtherPurchaseOrderPaymentList />
        </PermissionRoute>
      ),
    },
    {
      url: "gst-reconciliation",
      component: (
        <PermissionRoute permission="read:reconciliations">
          <GSTReconciliation />
        </PermissionRoute>
      ),
    },
    {
      url: "debit",
      component: (
        <PermissionRoute permission="read:accounts">
          <DebitList />
        </PermissionRoute>
      ),
    },
    {
      url: "debit/add",
      component: (
        <PermissionRoute permission="create:accounts">
          <ExpenseAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "debit/edit/:id",
      component: (
        <PermissionRoute permission="edit:accounts">
          <ExpenseEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "debit-office",
      component: (
        <PermissionRoute permission="read:accounts">
          <OfficeExpenseList />
        </PermissionRoute>
      ),
    },
    {
      url: "debit-office/add",
      component: (
        <PermissionRoute permission="create:accounts">
          <OfficeExpenseForm />
        </PermissionRoute>
      ),
    },
    {
      url: "debit-office/edit/:id",
      component: (
        <PermissionRoute permission="edit:accounts">
          <OfficeExpenseForm />
        </PermissionRoute>
      ),
    },
    {
      url: "contractual-debit",
      component: (
        <PermissionRoute permission="read:contractualwo">
          <ContractualWorkOrderList />
        </PermissionRoute>
      ),
    },
    {
      url: "contractual-debit/add",
      component: (
        <PermissionRoute permission="create:contractualwo">
          <ContractualWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractual-debit/edit/:id",
      component: (
        <PermissionRoute permission="edit:contractualwo">
          <ContractualWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-work-order/edit/:id",
      component: (
        <PermissionRoute permission="edit:contractualwo">
          <ContractualWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-work-orders/edit/:id",
      component: (
        <PermissionRoute permission="edit:contractualwo">
          <ContractualWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractual-work-order/edit/:id",
      component: (
        <PermissionRoute permission="edit:contractualwo">
          <ContractualWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractual-work-orders/edit/:id",
      component: (
        <PermissionRoute permission="edit:contractualwo">
          <ContractualWorkOrderAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "crm-and-hr",
      component: (
        <PermissionRoute permission="read:users">
          <HrAndCrm />
        </PermissionRoute>
      ),
    },

    // Material Delivery 
    {
      url: "delivery",
      component: (
        <PermissionRoute permission="read:deliveries">
          <DeliveryList />
        </PermissionRoute>
      ),
    },
    {
      url: "delivery/add",
      component: (
        <PermissionRoute permission="create:deliveries">
          <DeliveryAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "delivery/edit/:id",
      component: (
        <PermissionRoute permission="edit:deliveries">
          <DeliveryEdit />
        </PermissionRoute>
      ),
    },

    // Contractor Delivery Challan (Contractor DC)
    {
      url: "contractor-delivery",
      component: (
        <PermissionRoute permission={["read:contractor-deliveries"]}>
          <ContractorDeliveryList />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-delivery/add",
      component: (
        <PermissionRoute permission={["create:contractor-deliveries"]}>
          <ContractorDeliveryAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "contractor-delivery/edit/:id",
      component: (
        <PermissionRoute permission={["edit:contractor-deliveries"]}>
          <ContractorDeliveryAdd />
        </PermissionRoute>
      ),
    },

    // Material Inspection Report (MIR) 
    {
      url: "mir",
      component: (
        <PermissionRoute permission="read:mirs">
          <MIRList />
        </PermissionRoute>
      ),
    },
    {
      url: "mir/add",
      component: (
        <PermissionRoute permission="create:mirs">
          <MIRAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "mir/edit/:id",
      component: (
        <PermissionRoute permission="edit:mirs">
          <MIREdit />
        </PermissionRoute>
      ),
    },

    // Billings 
    {
      url: "billings",
      component: (
        <PermissionRoute permission="read:billings">
          <BillingList />
        </PermissionRoute>
      ),
    },
    {
      url: "billings/add",
      component: (
        <PermissionRoute permission="create:billings">
          <BillingAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "billings/edit/:id",
      component: (
        <PermissionRoute permission="edit:billings">
          <BillingEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "billing/overview",
      component: (
        <PermissionRoute permission="read:billings">
          <BillingOverview />
        </PermissionRoute>
      ),
    },
    {
      url: "billing-by-project",
      component: (
        <PermissionRoute permission="read:billings">
          <Billing />
        </PermissionRoute>
      ),
    },

    // JMR 
    {
      url: "jmr",
      component: (
        <PermissionRoute permission="read:jmrs">
          <JMRList />
        </PermissionRoute>
      ),
    },
    {
      url: "jmr/add",
      component: (
        <PermissionRoute permission="create:measurement-sheets">
          <Navigate to="/measurement-sheets/add" replace />
        </PermissionRoute>
      ),
    },
    {
      url: "jmr/edit/:id",
      component: (
        <PermissionRoute permission="edit:measurement-sheets">
          <Navigate to="/measurement-sheets" replace />
        </PermissionRoute>
      ),
    },

    // WIR
    {
      url: "wir",
      component: (
        <PermissionRoute permission="read:wirs">
          <WirList />
        </PermissionRoute>
      ),
    },
    {
      url: "wir/add",
      component: (
        <PermissionRoute permission="create:wirs">
          <WirAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "wir/edit/:id",
      component: (
        <PermissionRoute permission="edit:wirs">
          <WirEdit />
        </PermissionRoute>
      ),
    },

    // Measurement Sheets
    {
      url: "measurement-sheets",
      component: (
        <PermissionRoute permission="read:measurement-sheets">
          <MeasurementSheetList />
        </PermissionRoute>
      ),
    },
    {
      url: "measurement-sheets/add",
      component: (
        <PermissionRoute permission="create:measurement-sheets">
          <MeasurementSheetAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "measurement-sheets/edit/:id",
      component: (
        <PermissionRoute permission="edit:measurement-sheets">
          <MeasurementSheetEdit />
        </PermissionRoute>
      ),
    },

    // TCReport 
    {
      url: "tc-report",
      component: (
        <PermissionRoute permission="read:tcs">
          <TCReportList />
        </PermissionRoute>
      ),
    },
    {
      url: "tc-report/add",
      component: (
        <PermissionRoute permission="create:tcs">
          <TCReportAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "tc-report/edit/:id",
      component: (
        <PermissionRoute permission="edit:tcs">
          <TCReportEdit />
        </PermissionRoute>
      ),
    },

    // Handover 
    {
      url: "handover",
      component: (
        <PermissionRoute permission="read:handovers">
          <HandoverList />
        </PermissionRoute>
      ),
    },
    {
      url: "handover/readiness-dashboard",
      component: (
        <PermissionRoute permission="read:handovers">
          <HotoReadinessDashboard />
        </PermissionRoute>
      ),
    },
    {
      url: "handover/add",
      component: (
        <PermissionRoute permission="create:handovers">
          <HandoverAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "handover/edit/:id",
      component: (
        <PermissionRoute permission="edit:handovers">
          <HandoverEdit />
        </PermissionRoute>
      ),
    },

    // Dpr 
    {
      url: "dpr",
      component: (
        <PermissionRoute permission="read:dprs">
          <DprList />
        </PermissionRoute>
      ),
    },
    {
      url: "dpr/add",
      component: (
        <PermissionRoute permission="create:dprs">
          <DprAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "dpr/edit/:id",
      component: (
        <PermissionRoute permission="edit:dprs">
          <DprEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "dpr/manpower-dashboard",
      component: (
        <PermissionRoute permission="read:dprs">
          <ManpowerDashboard />
        </PermissionRoute>
      ),
    },
    {
      url: "dpr/hindrance-register",
      component: (
        <PermissionRoute permission="read:dprs">
          <HindranceRegister />
        </PermissionRoute>
      ),
    },
    {
      url: "projects",
      component: (
        <PermissionRoute permission="read:projects">
          <ProjectList />
        </PermissionRoute>
      ),
    },
    {
      url: "projects/:id/mcs",
      component: (
        <PermissionRoute permission="read:projects">
          <ProjectMcs />
        </PermissionRoute>
      ),
    },
    {
      url: "projects/:id/dpr",
      component: (
        <PermissionRoute permission="read:dprs">
          <DprList />
        </PermissionRoute>
      ),
    },
    {
      url: "milestones",
      component: (
        <PermissionRoute permission="read:projects">
          <MilestoneTracker />
        </PermissionRoute>
      ),
    },
    {
      url: "risk-register",
      component: (
        <PermissionRoute permission="read:projects">
          <RiskRegister />
        </PermissionRoute>
      ),
    },

    // Equipment Deployment & Utilization Tracking
    {
      url: "equipment",
      component: (
        <PermissionRoute permission="read:equipment">
          <EquipmentList />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/add",
      component: (
        <PermissionRoute permission="create:equipment">
          <EquipmentForm mode="add" />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/edit/:id",
      component: (
        <PermissionRoute permission="edit:equipment">
          <EquipmentForm mode="edit" />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/view/:id",
      component: (
        <PermissionRoute permission="read:equipment">
          <EquipmentView />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/deploy/:id",
      component: (
        <PermissionRoute permission="edit:equipment">
          <EquipmentDeploy mode="deploy" />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/return/:id",
      component: (
        <PermissionRoute permission="edit:equipment">
          <EquipmentDeploy mode="return" />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/idle-report",
      component: (
        <PermissionRoute permission="read:equipment">
          <IdleEquipmentReport />
        </PermissionRoute>
      ),
    },
    {
      url: "equipment/deployment-logs",
      component: (
        <PermissionRoute permission="read:equipment">
          <DeploymentLogs />
        </PermissionRoute>
      ),
    },

    // QC Inspections & Testing Records
    {
      url: "qc",
      component: (
        <PermissionRoute permission="read:qc">
          <QCList />
        </PermissionRoute>
      ),
    },
    {
      url: "qc/add",
      component: (
        <PermissionRoute permission="create:qc">
          <QCForm mode="add" />
        </PermissionRoute>
      ),
    },
    {
      url: "qc/edit/:id",
      component: (
        <PermissionRoute permission="edit:qc">
          <QCForm mode="edit" />
        </PermissionRoute>
      ),
    },
    {
      url: "qc/report",
      component: (
        <PermissionRoute permission="read:qc">
          <QCReport />
        </PermissionRoute>
      ),
    },

    // Safety Module
    {
      url: "safety",
      component: (
        <PermissionRoute permission="read:safety">
          <SafetyList />
        </PermissionRoute>
      ),
    },
    {
      url: "safety/add",
      component: (
        <PermissionRoute permission="create:safety">
          <SafetyForm mode="add" />
        </PermissionRoute>
      ),
    },
    {
      url: "safety/edit/:id",
      component: (
        <PermissionRoute permission="edit:safety">
          <SafetyForm mode="edit" />
        </PermissionRoute>
      ),
    },
    {
      url: "safety/report",
      component: (
        <PermissionRoute permission="read:safety">
          <SafetyReport />
        </PermissionRoute>
      ),
    },
    // Safety Compliance Checklists
    {
      url: "safety/checklists/add",
      component: (
        <PermissionRoute permission="create:safety">
          <SafetyChecklistForm mode="add" />
        </PermissionRoute>
      ),
    },
    {
      url: "safety/checklists/edit/:id",
      component: (
        <PermissionRoute permission="edit:safety">
          <SafetyChecklistForm mode="edit" />
        </PermissionRoute>
      ),
    },

    {
      url: "projects/add",
      component: (
        <PermissionRoute permission="create:projects">
          <ProjectAdd />
        </PermissionRoute>
      ),
    },
    {
      url: "projects/edit/:id",
      component: (
        <PermissionRoute permission="edit:projects">
          <ProjectEdit />
        </PermissionRoute>
      ),
    },
    {
      url: "reconciliation",
      component: (
        <PermissionRoute permission="read:reconciliations">
          <Reconciliation />
        </PermissionRoute>
      ),
    },
    {
      url: "project-categories",
      component: (
        <PermissionRoute permission="read:masters">
          <ProjectCategoryMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "product-categories",
      component: (
        <PermissionRoute permission="read:masters">
          <ProductCategoryMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "products",
      component: (
        <PermissionRoute permission="read:masters">
          <ProductMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "project-types",
      component: (
        <PermissionRoute permission="read:masters">
          <ProjectTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "project-menu-buttons",
      component: (
        <PermissionRoute permission="manage:masters">
          <ProjectMenuButtonMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "scope-types",
      component: (
        <PermissionRoute permission="read:masters">
          <ScopeTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "boq-unit-types",
      component: (
        <PermissionRoute permission="read:masters">
          <BoqUnitTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "expense-types",
      component: (
        <PermissionRoute permission="read:masters">
          <ExpenseTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "deduction-types",
      component: (
        <PermissionRoute permission="read:masters">
          <DeductionTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "measurement-sheet-types",
      component: (
        <PermissionRoute permission="read:masters">
          <MeasurementSheetTypeMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "activity-masters",
      component: (
        <PermissionRoute permission="read:masters">
          <ActivityMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "email-templates",
      component: (
        <PermissionRoute permission="read:masters">
          <EmailTemplateMaster />
        </PermissionRoute>
      ),
    },
    {
      url: "offices",
      component: (
        <PermissionRoute permission="read:masters">
          <OfficeMaster />
        </PermissionRoute>
      ),
    },
    ///Demo
    { url: "horizontal-sidebar", component: <Theme1 /> },
    { url: "nav-header", component: <Theme2 /> },
    { url: "dashboard-header", component: <Theme3 /> },
    { url: "primary-sidebar", component: <Theme4 /> },
    { url: "dark-sidebar", component: <Theme5 /> },
    { url: "mini-sidebar", component: <Theme6 /> },

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    { url: "post-details", component: <PostDetails /> },

    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <Customers /> },
    //
    ///// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },
    //
    ///// Bootstrap
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },
    //
    ///// Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-noui-slider", component: <MainNouiSlider /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "map-jqvmap", component: <JqvMap /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },
    //
    /////Redux
    // { url: "todo", component: Todo },
    //
    ///// Widget
    { url: "widget-basic", component: <Widget /> },

    ///// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },
    //
    ///// table
    { url: "table-filtering", component: <FilteringTable /> },
    { url: "table-sorting", component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },

    { url: "notifications", component: <AllNotifications /> },

    // Help & Support
    { url: "user-guides", component: <UserGuides /> },
    { url: "user-guides/add", component: <UserGuideAdd /> },
    { url: "user-guides/edit/:id", component: <UserGuideAdd /> },
  ];
  //let path = window.location.pathname;
  //path = path.split("/");
  //path = path[path.length - 1];

  //let pagePath = path.split("-").includes("page");
  //const { menuToggle } = useContext(ThemeContext);

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <Setting />
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, setMenuToggle } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${menuToggle ? "menu-toggle" : ""}`}
    >
      <Nav />
      {/* Ã°Å¸â€œÂ± Mobile Overlay: Closes sidebar when clicking outside on small screens */}
      {menuToggle && (
        <div
          className="nav-overlay"
          onClick={() => setMenuToggle(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 5,
            display: window.innerWidth <= 991 ? 'block' : 'none'
          }}
        />
      )}
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
